import type { Category, SubCategory } from "../../../redux/types/categoryTypes";

export interface SellingValues {
  title: string;
  description: string;
  gender: "" | "boys" | "girls" | "gender-neutral";
  categoryId: string;
  subcategoryId: string;
  upc: string;
  gtin: string;
  condition: "" | "new" | "used";
  quantity: string;
  conditionNotes: string;
  price: string;
  minimumOffer: string;
  shipping: string;
  length: string;
  width: string;
  height: string;
  pounds: string;
  ounces: string;
  returns: "" | "14-days" | "30-days" | "final" | "contact";
}

export const emptyListing: SellingValues = {
  title: "",
  description: "",
  gender: "",
  categoryId: "",
  subcategoryId: "",
  upc: "",
  gtin: "",
  condition: "",
  quantity: "1",
  conditionNotes: "",
  price: "",
  minimumOffer: "",
  shipping: "",
  length: "",
  width: "",
  height: "",
  pounds: "",
  ounces: "",
  returns: "",
};

export interface LocalPhoto {
  id: string;
  fingerprint: string;
  name: string;
  blob: Blob;
  previewUrl: string;
  width: number;
  height: number;
}

export const stepLabels = [
  "Toy Details",
  "Photos & Condition",
  "Pricing",
  "Shipping & Returns",
  "Review & List",
];
export const genderLabels = {
  boys: "Boys",
  girls: "Girls",
  "gender-neutral": "Gender Neutral",
};
export const returnPolicies = {
  "14-days": {
    label: "14-day returns",
    detail: "Buyers may request a return within 14 days of delivery.",
  },
  "30-days": {
    label: "30-day returns",
    detail: "Buyers may request a return within 30 days of delivery.",
  },
  final: {
    label: "All sales final",
    detail: "You do not offer discretionary returns.",
  },
  contact: {
    label: "Contact seller / Not specified",
    detail: "Buyers should contact you to discuss returns.",
  },
};

// Future server lifecycle. Expiry is distinct from deletion; no timers run here.
export type ListingStatus =
  | "active"
  | "out-of-stock"
  | "expired"
  | "inactive"
  | "deleted";

export interface ListingSelection {
  category: Category;
  subcategory: SubCategory;
}

export function selectListingCategory(
  categories: Category[],
  values: SellingValues,
): ListingSelection | null {
  const category = categories.find(
    (item) => item.source === "catalogue" && item.id === values.categoryId,
  );
  const subcategory = category?.subcategories?.find(
    (item) =>
      item.id === values.subcategoryId &&
      item.product_category === category.serial,
  );
  return category && subcategory ? { category, subcategory } : null;
}
